/*---------------------------------------------------------------------------------------------
 * Copyright (c) Bentley Systems, Incorporated. All rights reserved.
 * See LICENSE.md in the project root for license terms and full copyright notice.
 *--------------------------------------------------------------------------------------------*/
import * as React from 'react';
import cx from 'classnames';
import { IconButton } from '../Buttons/index.js';
import { useTheme, SvgCloseSmall } from '../utils/index.js';
import '@itwin/itwinui-css/css/information-panel.css';
/**
 * Header of the InformationPanel to be passed in the `header` prop.
 *
 * @example
 * <InformationPanelHeader
 *   onClose={() => {}}
 *   actions={(
 *     <>
 *       <IconButton styleType='borderless' onClick={() => {}}><SvgEdit /></IconButton>
 *       <IconButton styleType='borderless' onClick={() => {}}><SvgDelete /></IconButton>
 *     </>
 *   )}
 * >
 *   <Text variant='subheading'>InfoPanel heading</Text>
 * </InformationPanelHeader>
 */
export const InformationPanelHeader = (props) => {
    const { children, onClose, actions, className, ...rest } = props;
    useTheme();
    return (React.createElement("div", { className: cx('iui-information-header', className), ...rest },
        React.createElement("span", { className: 'iui-information-header-label' }, children),
        React.createElement("div", { className: 'iui-information-header-actions' },
            actions,
            onClose && (React.createElement(IconButton, { styleType: 'borderless', onClick: onClose, "aria-label": 'Close' },
                React.createElement(SvgCloseSmall, { "aria-hidden": true }))))));
};
export default InformationPanelHeader;
